module.exports = __webpack_public_path__ + "static/media/v-icon.50f228f5.svg";